export default {
  language: "zh_CN",
  timezone: "Asia/Shanghai",
  dateFormat: "YYYY-MM-DD",
  dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
  timeFormat: "HH:mm:ss"
};
